// TODO : vincent - need to incorporate various money library into it.
// Incorporae the following libraries:
// http://numeraljs.com/
// http://openexchangerates.github.io/accounting.js/
// https://sarahdayan.github.io/dinero.js/
// https://github.com/openexchangerates/accounting.js

export interface MoneyDatatypeInterface {
  data?: number;
}

export class MoneyDatatypeClass extends Number
  implements MoneyDatatypeInterface {
  data?: number;
}
